import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

const StickyCart = () => {
  const { items = [] } = useSelector((state) => state.cartitems);
  const userid = localStorage.getItem("userId");
  const location = useLocation();

  if (location.pathname === "/cart") return null;

  let count = 0;

  if (userid && items.length > 0) {
    count = items.length;
  } else {
    const tempCart = sessionStorage.getItem("temp_cart");
    try {
      const parsed = JSON.parse(tempCart);
      if (Array.isArray(parsed)) count = parsed.length;
    } catch (e) {
    }
  }

  if (count === 0) return null;

  return (
    <Link to="/cart" className="sticky-cart" aria-label="View Cart">
      <FontAwesomeIcon icon={faCartShopping} />
      <span className="sticky-count">{count}</span>
    </Link>
  );
};

export default StickyCart;
